import { BenefitType } from '@zorro/clients';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { Group, Stack, Text } from '@zorro/web/design-system';

import { buildBadges } from './ActivityLogBenefitTypeBadgesUtils';
import { EmployeeActivityLogPlanTypeBadge } from './PlanTypeBadge';

type Props = {
  benefitTypes?: BenefitType[];
  metadata?: Record<string, unknown> | null;
};

export const ActivityLogBenefitTypeBadges = ({
  benefitTypes,
  metadata,
}: Props) => {
  if (!benefitTypes || benefitTypes.length === 0) return null;

  const badges = buildBadges(benefitTypes, metadata);
  if (!badges) return null;

  return (
    <Group gap="xs">
      {badges.map(({ type, count, config, planLines }) => {
        const planWord = count === 1 ? 'Plan' : 'Plans';
        const plans = planLines.filter((plan) => plan.planName);

        const tooltipContent = (
          <Stack gap={0}>
            <Text c="var(--color-text-default-secondary)" size="sm">
              {count} {config.label} {planWord}
            </Text>
            {planLines.length > 0 && (
              <Text size="sm">
                {planLines
                  .map((plan) =>
                    [plan.carrierName, plan.planName]
                      .filter(Boolean)
                      .join(' - ')
                  )
                  .join(', ')}
              </Text>
            )}
          </Stack>
        );

        return (
          <Tooltip
            key={type}
            label={tooltipContent}
            position="top"
            disabled={plans.length === 0}
          >
            <EmployeeActivityLogPlanTypeBadge
              icon={config.icon}
              count={count}
            />
          </Tooltip>
        );
      })}
    </Group>
  );
};
